// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"userDocuments_wrapper_2zusU"};